import { useDispatch } from "react-redux";

import useShallowSelector from "./useShalowSelector";
import { IUser, ISignInRequestData, ISignUpRequestData, IUserTypes } from "../store/auth/types";
import { selectAuthUser, selectAuthLoading, selectAuthUserType, selectAuthErrors } from "../store/auth/selectors";
import { changeUserOptions } from "../store/ui/actionCreators";
import { selectUIUserOptions } from "../store/ui/selectors";
import { IError } from "../store/types/errors";

export interface onSignIn {
    (signInRequestData: ISignInRequestData): void;
}
export interface onSignUp {
    (signUpRequestData: ISignUpRequestData): void;
}
export interface onToggle {
    (): void;
}

type UseUser = () => {
    user: IUser | null;
    errors: IError | null;
    userType: IUserTypes;
    isLoading: boolean;
    isOpen: boolean;
    onToggle: onToggle;
};

export const useUser: UseUser = () => {
    const dispatch = useDispatch();

    const user = useShallowSelector(selectAuthUser);
    const userType = useShallowSelector(selectAuthUserType);
    const errors = useShallowSelector(selectAuthErrors);
    const isLoading = useShallowSelector(selectAuthLoading);
    const { isOpen } = useShallowSelector(selectUIUserOptions);

    const onToggle: onToggle = () => {
        dispatch(changeUserOptions({ isOpen: !isOpen }));
    };

    return { user, errors, userType, isLoading, isOpen, onToggle };
};
